export default __webpack_public_path__ + "static/media/cars.b62519f2.jpg";